export const localRouter_meun_zs_simple = [ //招商大脑 上海数据平台使用的简易版
//看项目投资趋势
{
    code: "P",
    switch: true,
    name: "",
    type: "tzqs",
    oldtext: "看投资趋势",
    url: "/invest-project-trend?type=3",
    open: true,
    morebtn: false,
    icontype: "el-icon-s-management",
    children: [
    // {	
    //     code: "P-QYZBCNDTZ",
    //     switch: true,
    //     name: "",
    //     oldtext: "企业在本市拿地投资项目",
    //     url: "/invest-project-trend?type=3"
    // },
    // {
    //     code: "P-SSGSZBCTZ",
    //     switch: true,
    //     name: "",
    //     oldtext: "上市公司在本市投资项目",
    //     // url: "/city-invest-project"
    //     url: "/invest-project-trend?type=1"
    // }, {
    //     code: "P-QYZBSNDTZ",
    //     switch: true,
    //     name: "",
    //     oldtext: "企业在本省拿地投资项目",
    //     url: "/invest-project-trend?type=4"
    // },{
    //     code: "P-SSGSZBSTZ",
    //     switch: true,
    //     name: "",
    //     oldtext: "上市公司在本省投资项目",
    //     // url: "/province-invest-project"
    //     url: "/invest-project-trend?type=2"
    // }, 
    // {
    //     code: "P-BSQYZWDTZ",
    //     switch: true,
    //     name: "",
    //     oldtext: "本市企业在外地投资项目",
    //     // url: "/province-invest-project"
    //     url: "/invest-project-trend?type=5"
    // }, 
    ]
},
{
    code: "G",
    switch: true,
    name: "重点产业招商",
    oldtext: "重点产业招商",
    type: "zdcywzzs",
    url: "/notionInvestment",
    open: true,
    icontype: "el-icon-s-management",
    children: [],
},
{
    code: "C",
    switch: true,
    name: "产业链招商",
    oldtext: "产业链招商",
    type: "cylzs",
    url: "/industryChain",
    open: true,
    icontype: "el-icon-s-management",
    children: [],
},
{
    code: "B",
    switch: true,
    name: "驻点招商",
    oldtext: "驻点招商",
    type: "zdzs",
    url: "/stationedCity",
    open: true,
    icontype: "el-icon-s-management",
    children: [],
},
{
    code: "J",
    switch: true,
    name: "",
    type: "jllx",
    oldtext: "以商招商",
    url: "/enterprisesCityRelation-province",
    open: true,
    morebtn: false,
    icontype: "el-icon-s-management",
    children: [
    //     {
    //     code: "J-GD",
    //     switch: true,
    //     name: "",
    //     oldtext: "本地企业外地股东",
    //     url: "/enterprisesCityRelation-province?type=1"
    // },  
    // {
    //     code: "J-DWTZ",
    //     switch: true,
    //     name: "",
    //     oldtext: "本地企业对外投资",
    //     url: "/enterprisesCityRelation-province?type=2"
    // }, 
    // {
    //     code: "J-GYS",
    //     switch: true,
    //     name: "",
    //     oldtext: "本地企业的外地供应商",
    //     url: "/enterprisesCityRelation-province?type=3"
    // }, 
    // {
    //     code: "J-KH",
    //     switch: true,
    //     name: "",
    //     oldtext: "本地企业的外地客户",
    //     url: "/enterprisesCityRelation-province?type=4"
    // }, 
    // {
    //     code: "J-TZJG",
    //     switch: true,
    //     name: "",
    //     oldtext: "相同投资机构下的外地企业",
    //     url: "/enterprisesCityRelation-province?type=6"
    // }, 
    ]
},
{
    code: "E",
    switch: true,
    name: "乡情招商",
    oldtext: "乡情招商",
    type: "xqzs",
    url: "/hometownInvestment",
    open: true,
    icontype: "el-icon-s-management",
    children: [],
},
{
    code: "D",
    switch: true,
    name: "科技招商",
    oldtext: "科技招商",
    type: "kjzs",
    url: "/science",
    open: true,
    icontype: "el-icon-s-management",
    children: [],
},
// {
//     code: "A",
//     switch: true,
//     name: "",
//     type: "tzqs",
//     oldtext: "找招商目标企业",
//     url: "/allchain",
//     open: true,
//     morebtn: false,
//     icontype: "el-icon-s-opportunity",
//     children: [ {
//         code: "A-CYTP",
//         switch: true,
//         name: "",
//         oldtext: "从产业图谱找企业",
//         url: "/allchain"
//     }, {
//         code: "A-ZDCYZQY",
//         switch: true,
//         name: "",
//         oldtext: "按重点产业找企业",
//         url: "/simple-enterprise-list?type=notion"
//     }, {
//         code: "A-ZDCSZQY",
//         switch: true,
//         name: "",
//         oldtext: "按重点城市找企业",
//         url: "/simple-enterprise-list?type=city"
//     },{
//         code: "A-CXQY",
//         switch: true,
//         name: "",
//         oldtext: "按融资阶段找企业",
//         url: "/enterpriseList?type=2"
//     },{
//         code: "A-QYLXZQY",
//         switch: true,
//         name: "",
//         oldtext: "按企业类型找企业",
//         url: "/simple-enterprise-list?type=strength"
//     }, {
//         code: "C-QYTZCK",
//         switch: true,
//         name: "",
//         oldtext: "从投资窗口期找企业",
//         url: "/enterpriseInvestmentWindow"
//     },
//     ]
// },
// {
//     code: "PDQY",
//     switch: true,
//     name: "",
//     type: "PDQY",
//     oldtext: "判断企业投资意向",
//     url: "/tenEnterprisesComparison",
//     open: true,
//     morebtn: false,
//     icontype: "el-icon-s-opportunity",
//     children: [{
//         code: "PD-ZHSL",
//         switch: true,
//         name: "",
//         oldtext: "判断企业综合实力",
//         url: "/tenEnterprisesComparison?type=1"
//     },  
//     {
//         code: "PD-CWSL",
//         switch: true,
//         name: "",
//         oldtext: "判断企业财务实力",
//         url: "/tenEnterprisesComparison?type=2"
//     }, 
//     {
//         code: "PD-TZDT",
//         switch: true,
//         name: "",
//         oldtext: "了解企业投资动态",
//         url: "/tenEnterprisesComparison?type=3"
//     }, 
//     {
//         code: "PD-TZBJ",
//         switch: true,
//         name: "",
//         oldtext: "了解企业投资布局",
//         url: "/tenEnterprisesComparison?type=4"
//     }, 
//     {
//         code: "PD-TZYX",
//         switch: true,
//         name: "",
//         oldtext: "判断企业投资意向",
//         url: "/tenEnterprisesComparison?type=5"
//     }, 
//     ]
// },

// {
//     code: "R",
//     switch: true,
//     name: "学习行业提升专业",
//     oldtext: "学习行业提升专业",
//     type: "yjbg",
//     url: "report",
//     open: true,
//     icontype: "el-icon-s-management",
//     children: [{
//             code: "T-CXQYRZ",
//             switch: true,
//             name: "",
//             oldtext: "数字经济研究报告",
//             url: "reportList",
//             reportId: 10005,
//         },
//         {
//             code: "T-CXQYRZ",
//             switch: true,
//             name: "",
//             oldtext: "高端制造研究报告",
//             url: "reportList",
//             reportId: 10014,
//         },
//         {
//             code: "T-CXQYRZ",
//             switch: true,
//             name: "",
//             oldtext: "能源环保材料研究报告",
//             url: "reportList",
//             reportId: 10024,
//         },
//         {
//             code: "T-CXQYRZ",
//             switch: true,
//             name: "",
//             oldtext: "大健康研究报告",
//             url: "reportList",
//             reportId: 10001,
//         },
//         {
//             code: "T-CXQYRZ",
//             switch: true,
//             name: "",
//             oldtext: "现代服务业研究报告",
//             url: "reportList",
//             reportId: 10018,
//         },
//         {
//             code: "T-CXQYRZ",
//             switch: true,
//             name: "",
//             oldtext: "大消费研究报告",
//             url: "reportList",
//             reportId: 10029,
//         },
//         {
//             code: "T-CXQYRZ",
//             switch: true,
//             name: "",
//             oldtext: "基建与投资研究报告",
//             url: "reportList",
//             reportId: 10034,
//         }, 
//     ],
// },
{
    code: "R",
    switch: true,
    name: "外资招商",
    oldtext: "外资招商",
    type: "wzzs",
    url: "/forcapEnterprise",
    open: true,
    icontype: "el-icon-s-management",
    children: [],
},

{
    code: "F",
    switch: true,
    name: "场景招商",
    oldtext: "场景招商",
    type: "cjzs",
    url: "/sceneInvestment",
    open: true,
    icontype: "el-icon-s-management",
    children: [],
},
]